<template>
    <div class="pt-4 border-top">
        <div v-if=" notifications.length">               
            <div class="card" v-for="notification in notifications" :key="'notification-' + notification.id">
                <div class="card-header">
                    <h5 class="d-inline mb-0">{{ notification.name }}</h5>
                    <button class="btn btn-primary btn-sm float-right" @click="showUsers(notification)"><i class="fas fa-user-plus fa-lg"></i></button>
                </div>
                <div class="card-body">
                    <div v-if="notificationUsers[notification.id] && notificationUsers[notification.id].length">
                        <span v-for="user in notificationUsers[notification.id]" :key="'notification-user-' + user.id" class="badge badge-pill border mr-1 ">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="confirm(user.full_name, notification.id, user.id)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div style="line-height: 1">{{ user.full_name }}</div>
                            <div style="line-height: 1">{{ user.email }}</div>
                            <div style="line-height: 1">{{ user.param | capitalize }}</div>                   
                        </span>
                    </div>
                    <div v-else>
                        <h5 class="text-muted text-center">No users have been set to receive this notification.</h5>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
             <h2 class="text-muted text-center">No notifications.</h2>
        </div> 

        <notification-users-modal @callback="refresh()"></notification-users-modal>
        <confirmation-modal></confirmation-modal>

    </div>
</template>

<script>
export default {
    props: {
        customerId: Number,
        notifications: Array,
        users: Array
    },
    data() {
        return {
            notificationUsers: []
        }
    },
    methods: {
        refresh: function () {
            axios.get('/ajax/admin/customers/' + this.customerId + '/notifications/users/')
                .then(response => {
                    this.notificationUsers = response.data;
                });
        },
        showUsers: function (notification) {
            var vm = this;
            var filteredUsers = vm.users.filter(function (x) { 
                return !vm.notificationUsers[notification.id].some(function (y) { 
                    return y.id == x.id; 
                })
            });

            eventHub.$emit('add-notification-user', filteredUsers, notification);
        },
        confirm: function (name, ...args) {
            const title = "Remove User from Notification Recipients";
            const message = '<div class="text-center mb-2">' +
                          '<h5 class="font-weight-bold d-inline"><i class="fas fa-exclamation-triangle text-warning"></i>WARNING</h5> - '+
                          '<span class="font-weight-bold">Notification parameters will be lost!</span>' +
                          '</div>' +
                          '<div>Are you sure you want to remove <b>' + name + '</b> from the list of recipients?</div>';
            eventHub.$emit('show-confirmation', title, message, this.remove, ...args);
        },
        remove: function (confirmed, ...args) {

            if (confirmed) {

                let notificationId = args[0];
                let userId = args[1];

                axios.delete('/ajax/admin/notifications/' + notificationId + '/users/' + userId)
                .then(response => {
                    this.refresh();
                })
                .catch(error => {
                    console.log(error.response.data);
                });
            }          
        }
    },
    created() {
        this.refresh();
    },
}
</script>

<style scoped>
    .badge {
        padding: 7px;
    }

    .badge .close {
        margin-left: .25rem;
        color: inherit;
        font-size: 100%;
        text-shadow: 0 1px 0 rgba(#000, .5);
    }

    [data-toggle="collapse"] .fa:before {   
        content: "\f139";
    }

    [data-toggle="collapse"].collapsed .fa:before {
        content: "\f13a";
    }  
</style>